export const hasMoreThanTwoDecimals = (value: string): boolean => {

    // Split the string at the decimal point
    if (!value.includes('.')) {
      return false;
    }
    const parts = value.split('.');

    // If there's no decimal part, it means the number has no decimals
    if (parts[1]?.length > 2) {
      return true;
    } else {
      return false
    }
  }